import {useEffect} from "react";
import {DispatchReactLoad} from "./Utilities";

export function useDispatchReactLoad() {
    useEffect(() => {
        DispatchReactLoad();
    });
}
